// Re-export AuthContext from shared package and configure it for Admin app
import { AuthProvider as SharedAuthProvider } from '@masonic-tools/shared-auth';
import { auth, db } from '@/lib/firebase';
import { showError, showSuccess } from '@/lib/swal';

// Re-export the useAuth hook for backwards compatibility
export { useAuth } from '@masonic-tools/shared-auth';

// Create a configured AuthProvider for the Admin app
export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <SharedAuthProvider
      auth={auth}
      db={db}
      onSuccess={showSuccess}
      onError={showError}
    >
      {children}
    </SharedAuthProvider>
  );
}

